export class ApplicationError extends Error {
  title: string | undefined;
  notification: string | undefined;

  constructor(message = 'An error has occurred in the Application') {
    super(message);

    this.name = 'ApplicationError';
    this.title = 'application.error.title';

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if ('captureStackTrace' in Error && typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor);
    }
  }

  static fromRuntimeError(error: Error) {
    const applicationError = new ApplicationError(error.message);
    applicationError.name = error.name;
    applicationError.stack = error.stack;
    return applicationError;
  }
}
